import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import CustomCheckbox from '../../shared/CustomCheckbox';

const useStyles = makeStyles({
  container: {
    height: '41px',
    width: '1015px',
    backgroundColor: '#E4E7EC',
    padding: '0px 12px 0px 12px',
    borderRadius: '8px',
    margin: ({ margin }) => margin || '0px',
  },
  text: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '16.08px',
    cursor: 'pointer',
  },
});
const SelectAll = ({ margin, dealershipCount, data, selected, handleChange, indeterminate }) => {
  const classes = useStyles({ margin });
  return (
    <Grid container justifyContent="space-between" alignItems="center" className={classes.container}>
      <Grid item>
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <CustomCheckbox
              size="small"
              handleChange={handleChange}
              selected={selected}
              indeterminate={indeterminate}
            />
          </Grid>
          <Grid item>
            <Typography variant="body2" className={classes.text}>
              {!selected ? 'Select All' : 'Unselect All'}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="body2" className={classes.text}>
          {`${data?.dealerships?.length} of ${dealershipCount} selected`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SelectAll;
